/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1TutoraiDashboardReportQueryResponse,
  GetApiV1TutoraiDashboardReportQueryParams,
  GetApiV1TutoraiDashboardReport400,
  GetApiV1TutoraiDashboardReport401,
  GetApiV1TutoraiDashboardReport500,
} from "../../types/tutorAIDashboardController/GetApiV1TutoraiDashboardReport.ts";

function getGetApiV1TutoraiDashboardReportUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/tutorai/dashboard/report` as const,
  };
  return res;
}

/**
 * @description Consolida métricas de custo e engajamento do TutorAI para um período obrigatório.
 * Filtros opcionais: `classStudentId` (turma) e `courseId` (curso).
 * `start` não pode ser posterior a `end`; `end` não pode ser uma data futura. **(Requer Authorization para autenticação)**
 * @summary Relatório administrativo de uso do chat (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/dashboard/report}
 */
export async function getApiV1TutoraiDashboardReport(
  params?: GetApiV1TutoraiDashboardReportQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1TutoraiDashboardReportQueryResponse,
    ResponseErrorConfig<
      | GetApiV1TutoraiDashboardReport400
      | GetApiV1TutoraiDashboardReport401
      | GetApiV1TutoraiDashboardReport500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1TutoraiDashboardReportUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
